export default "__VITE_ASSET__HktB3dbj__"